import React from "react";
import { FileText } from "lucide-react";
import { FILE_TYPE_COLORS, FILE_ICON_SIZE } from "../../constants";
import { getFileExtension } from "../../utils/fileUtils";

/**
 * Component to render the appropriate icon for a file
 * @param {Object} props - Component props
 * @param {string} props.fileName - The name of the file
 * @param {number} props.size - Icon size (optional)
 * @returns {JSX.Element} The file icon
 */
const FileIcon = ({ fileName, size = FILE_ICON_SIZE }) => {
  const ext = getFileExtension(fileName);
  const colorClass = FILE_TYPE_COLORS[ext] || FILE_TYPE_COLORS.default;

  // In the future, we can add specific icons for different file types
  // For now, we use FileText with different colors based on extension
  return <FileText size={size} className={colorClass} />;
};

export default FileIcon;
